import Vue from "vue";
import VueRouter from "vue-router";
import multiguard from "vue-router-multiguard";
import Home from "@/views/Home";
import Reports from "@/views/reports/Reports";
import MemberProfile from "@/views/members/MemberProfile";
import MonthlyActivityList from "@/views/activities/MonthlyActivityList";
import ContributionActivityList from "@/views/activities/ContributionActivityList";
import TrustSheetList from "@/views/trust-sheet/TrustSheetList";
import CpeMonthlyActivityList from "@/views/activities/CpeMonthlyActivityList";
import CpeContributionActivityList from "@/views/activities/CpeContributionActivityList";
import MonthlyActivityView from "@/views/activities/MonthlyActivityView";
import MonthlyActivityEdit from "@/views/activities/MonthlyActivityEdit";
import MonthlyActivityAdd from "@/views/activities/MonthlyActivityAdd";
import Projects from "@/views/service-projects/Projects";
import Members from "@/views/members/Members";
import MemberCreate from "@/views/members/MemberCreate";
import MemberEdit from "@/views/members/MemberEdit";
import ProjectCreate from "@/views/service-projects/ProjectCreate";
import ReviewProjects from "@/views/review-projects/ReviewProjects";
import ProjectInfo from "@/views/service-projects/ProjectInfo";
import Clubs from "@/views/club/Clubs";
import CreateClub from "@/views/club/CreateClub";
import EditClub from "@/views/club/EditClub";
import PublicClubMembers from "@/views/club/PublicClubMembers";

import Zone from "@/views/zone/Zone";
import CreateZone from "@/views/zone/CreateZone";
import EditZone from "@/views/zone/EditZone";

import SwitchRole from "@/components/auth/SwitchRole";

import Login from "@/components/auth/Login";
import MobileLogin from "@/components/auth/MobileLogin";
import MemberInfo from "@/components/members/MemberInfo";
import ForgotPassword from "@/components/auth/ForgotPassword";

const ifNotAuthenticated = (to, from, next) => {
  if (!localStorage.getItem("access_token")) {
    next();
    return;
  }
  next("/");
};

const ifAuthenticated = (to, from, next) => {
  if (localStorage.getItem("access_token")) {
    next();
    return;
  }
  next("/login");
};

const cpeRole = (to, from, next) => {
  if (localStorage.getItem("role") === "CLUBS_PERFORMANCE_EVALUATION") {
    next();
    return;
  }
  next("/");
};

const managerView = (to, from, next) => {
  let role = localStorage.getItem("role");
  switch (true) {
    case role === "CLUB_PRESIDENT":
      next();
      break;

    case role === "CLUB_SECRETARY":
      next();
      break;
    
    case role === "CLUB_TREASURER":
      next();
      break;
    
    case role === "CLUB_ADMINISTRATOR":
      next();
      break;

    case role === "ZONE_CHAIRPERSON":
      next();
      break;

    case role === "REGION_CHAIRPERSON":
      next();
      break;
    
    case role === "REGION_SECRETARY":
      next();
      break;
    
    case role === "REGION_CPE_COORDINATOR":
      next();
      break;

    case role === "CLUBS_PERFORMANCE_EVALUATION":
      next();
      break;
    
    case role === "DISTRICT_GOVERNOR":
      next();
      break;
    
    case role === "DISTRICT_GLOBAL_MEMBERSHIP_TEAM_COORDINATOR":
      next();
      break;
    
    case role === "CABINET_SECRETARY":
      next();
      break;
    
    case role === "PAST_DISTRICT_GOVERNOR":
      next();
      break;
    
    case role === "CABINET_TREASURER":
      next();
      break;
    
    case role === "DISTRICT_GLOBAL_ACTION_TEAM_COORDINATOR":
      next();
      break;
    
    case role === "DISTRICT_GLOBAL_LEADERSHIP_TEAM_COORDINATOR":
      next();
      break;
    
    case role === "DISTRICT_GLOBAL_SERVICE_TEAM_COORDINATOR":
      next();
      break;
    
    case role === "DISTRICT_LCIF_COORDINATOR":
      next();
      break;   
       

    default:
      next("activities/monthly");
      break;
  }
};

const manager = (to, from, next) => {
  let role = localStorage.getItem("role");
  switch (true) {
    case role === "CLUB_PRESIDENT":
      next();
      break;

    case role === "CLUB_SECRETARY":
      next();
      break;

    case role === "CLUB_TREASURER":
      next();
      break;

    case role === "CLUB_ADMINISTRATOR":
      next();
      break;

    case role === "CLUBS_PERFORMANCE_EVALUATION":
      next();
      break;

    default:
      next("/");
      break;
  }
};

const ServiceProjectView = (to, from, next) => {
  let role = localStorage.getItem("role");
  switch (true) {
    case role === "CLUB_PRESIDENT":
      next();
      break;

    case role === "CLUB_SECRETARY":
      next();
      break;

    case role === "CLUB_TREASURER":
      next();
      break;

    case role === "CLUB_ADMINISTRATOR":
      next();
      break;
  
    case role === "CLUB_GST_COORDINATOR":
      next();
      break;

    case role === "CLUB_MEMBER":
      next();
      break;

    case role === "ZONE_CHAIRPERSON":
      next();
      break;

    case role === "REGION_CHAIRPERSON":
      next();
      break;

    case role === "REGION_SECRETARY":
      next();
      break;

    case role === "REGION_CPE_COORDINATOR":
      next();
      break;

    case role === "REGION_GST_COORDINATOR":
      next();
      break;

    case role === "DISTRICT_GOVERNOR":
      next();
      break;

    case role === "CLUBS_PERFORMANCE_EVALUATION":
      next();
      break;

    case role === "DISTRICT_GLOBAL_SERVICE_TEAM_COORDINATOR":
      next();
      break;

    case role === "DISTRICT_GLOBAL_ACTION_TEAM_COORDINATOR":
      next();
      break;

    case role === "CABINET_SECRETARY":
      next();
      break;

    case role === "PRINCIPAL_COORDINATOR_CPE":
      next();
      break;

    default:
      next("/");
      break;
  }
};

const ServiceProjectCreate = (to, from, next) => {
  let role = localStorage.getItem("role");
  switch (true) {
    case role === "CLUB_PRESIDENT":
      next();
      break;

    case role === "CLUB_SECRETARY":
      next();
      break;

    case role === "CLUB_TREASURER":
      next();
      break;

    case role === "REGION_CHAIRPERSON":
      next();
      break;

    case role === "CLUB_ADMINISTRATOR":
      next();
      break;
    
    case role === "CLUB_GST_COORDINATOR":
      next();
      break;   
    

    case role === "REGION_GST_COORDINATOR":
      next();
      break;

    case role === "CLUBS_PERFORMANCE_EVALUATION":
      next();
      break;

    default:
      next("/");
      break;
  }
};

const ServiceProjectEdit = (to, from, next) => {
  let role = localStorage.getItem("role");
  switch (true) {
    case role === "CLUB_PRESIDENT":
      next();
      break;

    case role === "CLUB_SECRETARY":
      next();
      break;

    case role === "CLUB_TREASURER":
      next();
      break;

    case role === "REGION_CHAIRPERSON":
      next();
      break;

    case role === "CLUB_ADMINISTRATOR":
      next();
      break;
    
    case role === "CLUB_GST_COORDINATOR":
      next();
      break;   

    case role === "REGION_GST_COORDINATOR":
      next();
      break;

    case role === "CLUBS_PERFORMANCE_EVALUATION":
      next();
      break;

    default:
      next("/");
      break;
  }
};

const supperAdminView = (to, from, next) => {
  let role = localStorage.getItem("role");
  switch (true) {
    case role === "CLUBS_PERFORMANCE_EVALUATION":
      next();
      break;

    case role === "CLUB_TREASURER":
      next();
      break;

    case role === "CABINET_SECRETARY":
      next();
      break;
    
     case role === "CABINET_TREASURER":
      next();
      break;

    case role === "REGION_CHAIRPERSON":
      next();
      break;
    
    case role === "DISTRICT_GLOBAL_MEMBERSHIP_TEAM_COORDINATOR":
      next();
      break;

    case role === "DISTRICT_GLOBAL_LEADERSHIP_TEAM_COORDINATOR":
      next();
      break;
    
    case role === "DISTRICT_GLOBAL_ACTION_TEAM_COORDINATOR":
      next();
      break;
    
     case role === "DISTRICT_GLOBAL_SERVICE_TEAM_COORDINATOR":
      next();
      break;

    case role === "DISTRICT_GOVERNOR":
      next();
      break;

    case role === "ZONE_CHAIRPERSON":
      next();
      break;

    case role === "REGION_GMT_COORDINATOR":
      next();
      break;
    
    case role === "REGION_CPE_COORDINATOR":
      next();
      break;
    
    case role === "FIRST_VICE_DISTRICT_GOVERNOR":
      next();
      break;
    
    case role === "SECOND_VICE_DISTRICT_GOVERNOR":
      next();
      break;
    
     case role === "PAST_DISTRICT_GOVERNOR":
      next();
      break;
    
    case role === "REGION_SECRETARY":
      next();
      break;
    
    case role === "DISTRICT_GLOBAL_EXTENSION_TEAM_(GET)_COORDINATOR":
      next();
      break;
    
    case role === "REGION_GET_COORDINATOR":
      next();
      break;
    
    

    default:
      next("/");
      break;
  }
};

const supperAdmin = (to, from, next) => {
  let role = localStorage.getItem("role");
  switch (true) {
    case role === "CLUBS_PERFORMANCE_EVALUATION":
      next();
      break;

    case role === "CLUB_TREASURER":
      next();
      break;

    case role === "CABINET_SECRETARY":
      next();
      break;
    
     case role === "CABINET_TREASURER":
      next();
      break;

    case role === "REGION_CHAIRPERSON":
      next();
      break;
    
    case role === "DISTRICT_GLOBAL_MEMBERSHIP_TEAM_COORDINATOR":
      next();
      break;

    case role === "DISTRICT_GLOBAL_LEADERSHIP_TEAM_COORDINATOR":
      next();
      break;
    
    case role === "DISTRICT_GLOBAL_ACTION_TEAM_COORDINATOR":
      next();
      break;
    
     case role === "DISTRICT_GLOBAL_SERVICE_TEAM_COORDINATOR":
      next();
      break;

    case role === "DISTRICT_GOVERNOR":
      next();
      break;

    case role === "ZONE_CHAIRPERSON":
      next();
      break;

    case role === "REGION_GMT_COORDINATOR":
      next();
      break;
    
    case role === "REGION_CPE_COORDINATOR":
      next();
      break;
    
    case role === "FIRST_VICE_DISTRICT_GOVERNOR":
      next();
      break;
    
    case role === "SECOND_VICE_DISTRICT_GOVERNOR":
      next();
      break;
    
     case role === "PAST_DISTRICT_GOVERNOR":
      next();
      break;
    
    case role === "REGION_SECRETARY":
      next();
      break;  

    default:
      next("/");
      break;
  }
};

const memberManager = (to, from, next) => {
  let role = localStorage.getItem("role");
  switch (true) {
    case role === "CLUB_PRESIDENT":
      next();
      break;

    case role === "CLUB_SECRETARY":
      next();
      break;

    case role === "CLUB_TREASURER":
      next();
      break;

    case role === "CLUBS_PERFORMANCE_EVALUATION":
      next();
      break;

    case role === "REGION_CPE_COORDINATOR":
      next();
      break;

    case role === "CLUB_ADMINISTRATOR":
      next();
      break;

    case role === "DISTRICT_GOVERNOR":
      next();
      break;

    case role === "REGION_CHAIRPERSON":
      next();
      break;

    default:
      next("/");
      break;
  }
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    meta: { activePath: "/" },
    component: Home,
    beforeEnter: multiguard([ifAuthenticated]),
  },

  {
    path: "/profile",
    name: "MemberProfile",
    meta: { activePath: "profile" },
    component: MemberProfile,
    beforeEnter: multiguard([ifAuthenticated]),
  },

  {
    path: "/login",
    name: "Login",
    component: Login,
    beforeEnter: ifNotAuthenticated,
  },

  {
    path: "/switch-role",
    name: "SwitchRole",
    component: SwitchRole,
    beforeEnter: ifAuthenticated,
  },

  {
    path: "/app-login",
    name: "AppLogin",
    component: MobileLogin,
    beforeEnter: ifNotAuthenticated,
  },

  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: ForgotPassword,
    beforeEnter: ifNotAuthenticated,
  },

  {
    path: "/club-members/:uuid",
    name: "PublicClubMembers",
    component: PublicClubMembers,
    meta: { publicPage: true },
  },

  {
    path: "/activities/monthly",
    name: "MonthlyActivityList",
    component: MonthlyActivityList,
    beforeEnter: multiguard([ifAuthenticated, managerView]),
  },

  {
    path: "/activities/monthly/add/:month/:key",
    name: "MonthlyActivityAdd",
    component: MonthlyActivityAdd,
    beforeEnter: multiguard([ifAuthenticated, manager]),
  },

  {
    path: "/cpe-activities/monthly",
    name: "CpeMonthlyActivityList",
    component: CpeMonthlyActivityList,
    beforeEnter: multiguard([ifAuthenticated, cpeRole]),
  },

  {
    path: "/activities/contributions",
    name: "ContributionActivityList",
    component: ContributionActivityList,
    beforeEnter: multiguard([ifAuthenticated, managerView]),
  },

  {
    path: "/activities/contributions/add/:month/:key",
    name: "ContributionActivityAdd",
    component: MonthlyActivityAdd,
    beforeEnter: multiguard([ifAuthenticated, manager]),
  },

  {
    path: "/activities/contributions/edit/:aId/:month/:key",
    name: "ContributionActivityEdit",
    component: MonthlyActivityEdit,
    beforeEnter: multiguard([ifAuthenticated, manager]),
  },

  {
    path: "/activities/contributions/view/:aId/:month/:key",
    name: "ContributionActivityView",
    component: MonthlyActivityView,
    beforeEnter: multiguard([ifAuthenticated, managerView]),
  },

  {
    path: "/cpe-activities/contributions",
    name: "CpeContributionActivityList",
    component: CpeContributionActivityList,
    beforeEnter: multiguard([ifAuthenticated, cpeRole]),
  },

  {
    path: "/activities/monthly/edit/:aId/:month/:key",
    name: "MonthlyActivityEdit",
    component: MonthlyActivityEdit,
    beforeEnter: multiguard([ifAuthenticated, manager]),
  },

  {
    path: "/activities/monthly/view/:aId/:month/:key",
    name: "MonthlyActivityView",
    component: MonthlyActivityView,
    beforeEnter: multiguard([ifAuthenticated, managerView]),
  },

  {
    path: "/projects",
    name: "Projects",
    component: Projects,
    beforeEnter: multiguard([ifAuthenticated, ServiceProjectView]),
  },

  {
    path: "/projects/create",
    name: "ProjectCreate",
    component: ProjectCreate,
    beforeEnter: multiguard([ifAuthenticated, ServiceProjectCreate]),
  },

  {
    path: "/review/projects",
    name: "ReviewProjects",
    component: ReviewProjects,
    beforeEnter: multiguard([ifAuthenticated, manager]),
  },

  {
    path: "/projects/edit/:step/:uuid",
    name: "ProjectEdit",
    component: ProjectCreate,
    beforeEnter: multiguard([ifAuthenticated, ServiceProjectEdit]),
  },

  {
    path: "/projects/info/:uuid",
    name: "ProjectInfo",
    component: ProjectInfo,
    beforeEnter: multiguard([ifAuthenticated, ServiceProjectView]),
  },

  {
    path: "/members",
    name: "Members",
    component: Members,
    beforeEnter: multiguard([ifAuthenticated]),
  },

  {
    path: "/members/info/:id",
    name: "MemberInfo",
    component: MemberInfo,
    beforeEnter: multiguard([ifAuthenticated]),
  },

  {
    path: "/members/create",
    name: "MemberCreate",
    component: MemberCreate,
    beforeEnter: multiguard([ifAuthenticated, memberManager]),
  },

  {
    path: "/members/edit/:uuid",
    name: "MemberEdit",
    component: MemberEdit,
    beforeEnter: multiguard([ifAuthenticated, memberManager]),
  },

  {
    path: "/clubs",
    name: "Clubs",
    component: Clubs,
    beforeEnter: multiguard([ifAuthenticated, supperAdminView]),
  },

  {
    path: "/clubs/create",
    name: "CreateClub",
    component: CreateClub,
    beforeEnter: multiguard([ifAuthenticated, supperAdmin]),
  },

  {
    path: "/clubs/edit/:uuid",
    name: "EditClub",
    component: EditClub,
    beforeEnter: multiguard([ifAuthenticated, supperAdmin]),
  },

  {
    path: "/zone",
    name: "Zone",
    component: Zone,
    beforeEnter: multiguard([ifAuthenticated, cpeRole]),
  },

  {
    path: "/zone/create",
    name: "CreateZone",
    component: CreateZone,
    beforeEnter: multiguard([ifAuthenticated, cpeRole]),
  },

  {
    path: "/zone/edit/:id",
    name: "EditZone",
    component: EditZone,
    beforeEnter: multiguard([ifAuthenticated, cpeRole]),
  },

  {
    path: "/reports",
    name: "Reports",
    component: Reports,
    beforeEnter: multiguard([ifAuthenticated]),
  },
  {
    path: "/trust-sheet",
    name: "TrustSheetList",
    component: TrustSheetList,
    beforeEnter: multiguard([ifAuthenticated, managerView]),
  },

  
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
